<ng-container #visual></ng-container>